import React, { useState, useEffect } from "react";
import { useNavigate , useLocation} from "react-router-dom";
import Swal from "sweetalert2";
import request from "../../Apis/request";
import { BaseURL, uniqueToken } from "../../api/DataApis";
import axios from "axios";
import { useParams } from "react-router-dom";

function Edit(props) {
  document.title = "Versions | Update";
  let navigate = useNavigate();
   let location = useLocation();
    let VersionEditData = location?.state?.VersionEditData;


   
    console.log("VersionEditData", VersionEditData);
    let params = useParams();
    let VersionID = params?.wid;
    console.log("versionsssID",VersionID);



  const [AndroidNewVersion, setAndroidNewVersion] = useState("");
  const [AndroidOldVersion, setAndroidOldVersion] =  useState("");
  const [IosOldVersion, setIosoldversion] = useState("");
  const [IosNewVersion, setIosnewversion] = useState("");
 

  
  const data = {
    "android_latest_version" : AndroidNewVersion,
    "android_old_version" : AndroidOldVersion,
    "ios_latest_version" : IosNewVersion,
     "ios_old_version" : IosOldVersion
   
}

  const handleAndroidNewVersionChange = (e) => {
  setAndroidNewVersion(e.target.value);
  };
  const handleAndroidOldVersionsChange = (e) => {
  setAndroidOldVersion(e.target.value);
  };
  const handleIOSNewVersionChange = (e) => {
  setIosnewversion(e.target.value);
    };
  const handleIOSOldVersionsChange = (e) => {
  setIosnewversion(e.target.value);
    };


  useEffect(() => {
    if (VersionEditData) {
      setAndroidNewVersion(VersionEditData?.android_latest_version || "");
      setAndroidOldVersion(VersionEditData?.android_old_version);
      setIosoldversion(VersionEditData?.ios_old_version || "");
      setIosnewversion(VersionEditData?.ios_latest_version || "");
      // setSelectedFile(FilterCategoryEditData?.master_image || null);
      
    }
  }, [VersionEditData]);
  
  const UpdateVersion = async (FilterCategoryEditData) => {

 Swal.fire({
      title: 'Updating Version...',
      text: 'Please wait',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    // Make the API request
    let response = await request({
       url: `${BaseURL}/version/edit/${VersionID}`,
      method: "PUT",
      data: data,
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${uniqueToken}`,
      }
    });
  
    // Handle the response
    if (response.statusCode === 200) {
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Version Updated Successfully...",
        showConfirmButton: false,
        timer: 1500,
      });
      navigate(`/versions`);
    } else {
      // Handle errors
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update Filter Category",
      });
    }
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <h1 className="page-title"></h1>
              <div className="portlet light bordered">
                <div className="portlet-title row">
                  <div className="caption font-dark col-md-10">
                    <h4 className="caption-subject bold uppercase mx-3">
                      Versions Edit
                    </h4>
                  </div>
                  <div className="caption font-dark col-md-2">
                    <h5 className="caption-subject bold uppercase mx-3">
                      <button className="btn btn-success" onClick={() => navigate(-1)}>
                        Back
                      </button>
                    </h5>
                  </div>
                </div>
                <div className="portlet-body mx-3">
                  <hr style={{ marginTop: "" }} />
                  <div className="row">
                    <div className="col-sm-12">
                      <form
                        className="form-horizontal"
                        encType="multipart/form-data"
                        role="form"
                        method="post"
                        style={{ marginTop: "-20px" }}
                      >
                        <div className="form-group">
                          <div className="row">
                            <label
                              htmlFor="name_id"
                              className="col-sm-2 control-label"
                            >
                           Android  Old Version
                            </label>
                            <div className="col-sm-6">
                              <input
                              value={AndroidOldVersion}
                                onChange={handleAndroidOldVersionsChange}
                                className="form-control"
                                id="name_id"
                                name="name"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                      

                        <div className="form-group">
                          <div className="row">
                            <label
                              htmlFor="name_id"
                              className="col-sm-2 control-label"
                            >
                            Android New Versions
                            </label>
                            <div className="col-sm-6">
                              <input
                              type="text"
                              value={AndroidNewVersion}
                             onChange={handleAndroidNewVersionChange}
                          
                                className="form-control"
                                id="file"
                                name="file"
                              />
                            </div>
             
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label
                              htmlFor="name_id"
                              className="col-sm-2 control-label"
                            >
                            IOS Old Versions
                            </label>
                            <div className="col-sm-6">
                              <input
                              type="text"
                              value={IosOldVersion}
                             onChange={handleIOSOldVersionsChange}
                          
                                className="form-control"
                                id="file"
                                name="file"
                              />
                            </div>
             
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label
                              htmlFor="name_id"
                              className="col-sm-2 control-label"
                            >
                            IOS New Versions
                            </label>
                            <div className="col-sm-6">
                              <input
                              type="text"
                              value={IosNewVersion}
                             onChange={handleIOSNewVersionChange}
                          
                                className="form-control"
                                id="file"
                                name="file"
                              />
                            </div>
             
                          </div>
                        </div>


                                            <div className="form-group">
                          <div className="col-sm-offset-2 col-sm-8 add-class">
                            <input
                              type="button"
                              className="btn btn-success"
                              onClick={() => UpdateVersion(VersionEditData)}
                              //ssssonClick={UpdateFilterCategory(FilterCategoryEditData)}
                              value="Update Version"
                            />
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Edit;
